import { Link } from "react-router-dom";
import "../../styles/art/ProgramSection.css";

const programs = [
  {
    id: 1,
    slug: "lop-trai-nghiem",
    title: "LỚP TRẢI NGHIỆM",
    image: "/images/art/programs/program1.webp",
  },
  {
    id: 2,
    slug: "chuong-trinh-can-ban-kid",
    title: "CHƯƠNG TRÌNH CĂN BẢN (KID)",
    image: "/images/art/programs/program2.webp",
  },
  {
    id: 3,
    slug: "chuong-trinh-nang-cao-top",
    title: "CHƯƠNG TRÌNH NÂNG CAO (TOP)",
    image: "/images/art/programs/program3.webp",
  },
  {
    id: 4,
    slug: "chuong-trinh-my-thuat-ung-dung",
    title: "CHƯƠNG TRÌNH MỸ THUẬT ỨNG DỤNG",
    image: "/images/art/programs/program4.webp",
  },
];

function ProgramSection() {
  return (
    <section className="program-section">
      <div className="program-section__container">
        <div className="program-section__header">
          <h2 className="program-section__title">CHƯƠNG TRÌNH HỌC</h2>
        </div>

        <div className="program-section__grid">
          {programs.map((program) => (
            <Link
              key={program.id}
              to={`/art/programs/${program.slug}`}
              className="program-card"
              aria-label={`Xem chi tiết ${program.title}`}
            >
              <img
                src={program.image}
                alt={program.title}
                className="program-card__image"
              />
              <p className="program-card__title">{program.title}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProgramSection;
